import React from 'react';
import styled, { css } from 'styled-components';
import { PRODUCT_GROUP_SIZES } from '../product-list/product-list.constants';

type ProductCardGridProps = {
  children: React.ReactNode;
  dataTestId?: string;
};

export const ProductCardGrid = ({ children, dataTestId }: ProductCardGridProps): JSX.Element => (
  <Grid data-testid={dataTestId} breakpoints={PRODUCT_GROUP_SIZES.grid}>
    {children}
  </Grid>
);

const Grid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(${({ breakpoints }) => breakpoints.sm.rowSize}, 1fr);
  margin: 0 0 20px;

  ${({ breakpoints }) =>
    Object.values(breakpoints).map(
      ({ breakpoint, rowSize }) => css`
        @media (min-width: ${breakpoint}px) {
          grid-template-columns: repeat(${rowSize}, 1fr);
        }
      `
    )}
`;
